export enum Role {
  SuperAdmin = 1,
  Admin = 2,
  User = 3,
  NotAssign = 0,
}

export const RoleMapping: Record<Role, string> = {
  [Role.SuperAdmin]: 'Super Admin',
  [Role.Admin]: 'Admin',
  [Role.User]: 'User',
  [Role.NotAssign]: '-',
};

export enum DriveType {
  External = 1,
  Local = 2,
}

export const DriveTypeMapping: Record<DriveType, string> = {
  [DriveType.External]: 'External',
  [DriveType.Local]: 'Local',
};

export const SortOrderType = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const KeywordJobStatus = {
  Pending: 1,
  Completed: 2,
  Error: 3,
};

export enum CrawlJobProgressStatus {
  Pending = 1,
  Crawling = 2,
  Indexing = 3,
  Completed = 4,
  Error = 5,
  Terminated = 6,
}

export const StatusMapping: Record<CrawlJobProgressStatus, string> = {
  [CrawlJobProgressStatus.Pending]: 'Pending',
  [CrawlJobProgressStatus.Crawling]: 'Crawling',
  [CrawlJobProgressStatus.Indexing]: 'Indexing',
  [CrawlJobProgressStatus.Completed]: 'Completed',
  [CrawlJobProgressStatus.Error]: 'Error',
  [CrawlJobProgressStatus.Terminated]: 'Terminated',
};
export enum HitCountJobProgressStatus {
  Pending = 1,
  KeyMatching = 2,
  Completed = 3,
  Error = 4,
}
export const HitCountStatusMapping: Record<HitCountJobProgressStatus, string> = {
  [HitCountJobProgressStatus.Pending]: 'Pending',
  [HitCountJobProgressStatus.KeyMatching]: 'KeyMatching',
  [HitCountJobProgressStatus.Completed]: 'Completed',
  [HitCountJobProgressStatus.Error]: 'Error',
};
export enum RequestType {
  NewSite = 1,
  ReCrawl = 2,
}

export const RequestMapping: Record<RequestType, string> = {
  [RequestType.NewSite]: 'New Site',
  [RequestType.ReCrawl]: 'Re-Crawl',
};

export enum SiteIndexStatus {
  InProgress = 1,
  Failed = 2,
  Completed = 3,
}

export const DMCALinkStatus = {
  IsMarkedDmca: 1,
  IsMarkedRevisit: 2,
  IsMarkedIgnore: 3,
};

export enum WeblinkSource {
  Online = 1,
  Index = 2,
}

export enum SiteStatus {
  Unknown = 0,
  NewSite = 1,
  RequestRecrawl = 2,
  Crawling = 3,
  Indexing = 4,
  HitCounting = 5,
  Processed = 6,
  Terminated = 7,
}

export const SiteMapping: Record<SiteStatus, string> = {
  [SiteStatus.Unknown]: '-',
  [SiteStatus.NewSite]: 'New Site', //green
  [SiteStatus.RequestRecrawl]: 'Recrawl', //orange
  [SiteStatus.Crawling]: 'Crawling', //blue
  [SiteStatus.Indexing]: 'Indexing', //blue
  [SiteStatus.HitCounting]: 'HitCounting', //blue
  [SiteStatus.Processed]: 'Processed',
  [SiteStatus.Terminated]: 'Terminated', //red
};
